import styled from "styled-components";

export const FloatingButton = styled.button`
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    border: none;
    background-color: ${({ $primaryColor }) => $primaryColor || "#2563eb"};
    color: #ffffff;
    font-size: 24px;
    cursor: pointer;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: transform 0.2s ease-out, box-shadow 0.2s ease-out;

    &:hover {
        transform: translateY(-2px) scale(1.03);
        box-shadow: 0 6px 14px rgba(0, 0, 0, 0.25);
    }

    &:active {
        transform: translateY(0) scale(0.98);
        box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
    }
`;

export const ChatWindow = styled.div`
    position: fixed;
    bottom: 90px;
    right: 20px;
    width: 360px;
    max-width: 95vw;
    height: 520px;
    max-height: 80vh;
    background-color: #ffffff;
    border-radius: 16px; 
    border: 1px solid #e5e5e5; 
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    z-index: 9999;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
    
    opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
    transform: translateY(${({ $isOpen }) => ($isOpen ? "0" : "16px")})
    scale(${({ $isOpen }) => ($isOpen ? 1 : 0.97)});
    pointer-events: ${({ $isOpen }) => ($isOpen ? "auto" : "none")};
    transition:
            opacity 0.22s ease-out,
            transform 0.22s ease-out;
`;


export const ChatHeader = styled.div`
    padding: 10px 12px;
    background-color: ${({ $primaryColor }) => $primaryColor || "#2563eb"};
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    font-size: 14px;
`;

export const CloseButton = styled.button`
    background: transparent;
    border: none;
    color: #ffffff;
    font-size: 18px;
    cursor: pointer;
    line-height: 1;
`;

export const ChatBody = styled.div`
    flex: 1;
    background-color: #f9fafb;
`;

export const ChatIframe = styled.iframe`
    width: 100%;
    height: 100%;
    border: none;
`;
